import React from "react";

const Java_rint = () => {
  return (
    <div>
      <h1>Java rint</h1>
      <p>This page provides explanations, examples, and common use-cases for Java rint in Java.</p>
    </div>
  );
};

export default Java_rint;
